"use strict";
exports.__esModule = true;
exports.STATE_FL = exports.collectionXLabelField = exports.taxFilingStatusGroup = exports.objRevenueTypes = void 0;
var enums_1 = require("./enums");
exports.objRevenueTypes = {
    TAXABLE_PURCHASE: {
        index: "B",
        label: "Taxable Purchase",
        key: "TAXABLE_PURCHASE"
    },
    SALES_AND_SERVICE: {
        index: "A",
        label: "Sales/Service/Electricity Revenue",
        key: "SALES_AND_SERVICE"
    },
    COMMERCIAL_RENTAL: {
        index: "C",
        label: "Commercial Rental",
        key: "COMMERCIAL_RENTAL"
    },
    TRANSIENT_RENTALS: {
        index: "D",
        label: "Transient Rentals",
        key: "TRANSIENT_RENTALS"
    },
    FOOD_AND_BEVERAGE: {
        index: "E",
        label: "Food And Beverage",
        key: "FOOD_AND_BEVERAGE"
    }
};
/**
 * @interface taxFilingStatusGroup
 * Some status group which needs to be taken care of.
 */
exports.taxFilingStatusGroup = {
    /** Only allow to update revenue for following status */
    ACCEPT_REVENUE: [
        enums_1.TAX_FILING_STATUS.PENDING_REVENUE,
        enums_1.TAX_FILING_STATUS.AWAITING_APPROVAL,
    ],
    /** Bot should only run by user only if filing is in following status */
    FILING_BOT_CAN_START: [
        enums_1.TAX_FILING_STATUS.READY_TO_FILE_TAX,
        enums_1.TAX_FILING_STATUS.FAILED,
        enums_1.TAX_FILING_STATUS.PENDING_REVIEW,
    ],
    /** No update to tax filing should be done to filing having this status */
    DISALLOW_UPDATE: [
        enums_1.TAX_FILING_STATUS.SUCCESS,
        enums_1.TAX_FILING_STATUS.PROCESSING,
        enums_1.TAX_FILING_STATUS.WAITING_TO_BE_STARTED,
        enums_1.TAX_FILING_STATUS.FILING_STARTED,
    ]
};
exports.collectionXLabelField = {
    "sub-client": ["CorporationName"],
    "master-client": ["CorporationName"],
    "tax-filings": ["SubClient.CorporationName", "Month"],
    state: ["StateName"],
    "business-entity": ["CorporationName"]
};
// This will create problem in future for sure.
// State ids were modified on very later stage where Florida id was used in many schemas.
// Now state ids are State codes so we can take desicion based on state ID. But Florida is exception.
exports.STATE_FL = "638ec10d81362bba4faff769";
//# sourceMappingURL=constants.js.map